import {createManholeGeometry} from "./manholeGeometry";
import {Line, DashedLine} from "../../../Renderer/primitives";
import React from "react";
import {Group, Shape} from "react-konva";
import {renderTypePlates, renderVerticalClosureIntersections} from "./renderer";
import {getClosureSizes} from "../../../../domain/manhole";

export const SubFloorManhole = ({ lidGeometry, scale, manhole }) => {
    const manholeGeometry = createManholeGeometry(manhole, scale, lidGeometry)
    const renderHoldingBrackets = () => {
        const getHorizontalSpacing = () => 13.5 * scale
        const getVerticalSpacing = () => 8.5 * scale
        const renderBracket = (x, y) => {
            const getDiameter = () => getClosureSizes(manhole.type).bracketDiameter * scale
            const getWidth = () => getClosureSizes(manhole.type).bracketWidth * scale // center to center
            // distance
            const getRightCenterX = () => getWidth() / 2
            const getLeftCenterX = () => -getRightCenterX()
            const getRadius = () => getDiameter() / 2

            return (<Group x={x} y={y}>
                <Shape
                    sceneFunc={(context, shape) => {
                        context.beginPath()
                        context.arc(getLeftCenterX(), 0, getRadius(), Math.PI / 2, -Math.PI / 2, false)
                        context.arc(getRightCenterX(), 0, getRadius(), -Math.PI / 2, Math.PI / 2, false)
                        context.closePath()
                        context.fillStrokeShape(shape)
                    }}
                    stroke="black"
                    fill="black"
                    strokeWidth={1}
                />
            </Group>)
        }

        return (
            [
                manholeGeometry.left,
                ...manholeGeometry.verticalClosureIntersectionsX].map(x => [
                manholeGeometry.top,
                ...manholeGeometry.horizontalClosureIntersectionsY
            ].map(y =>
                <Group x={x} y={y} key={'bracket_' + x + '_' + y}>
                    {renderBracket(getHorizontalSpacing(), getVerticalSpacing())}
                    {renderBracket(getHorizontalSpacing(), manholeGeometry.closureHeight - getVerticalSpacing())}
                </Group>))
        )
    }
    const renderManholeOutline = () => <Line points={
        [
            manholeGeometry.left,
            manholeGeometry.top,
            manholeGeometry.left,
            manholeGeometry.bottom,
            manholeGeometry.right,
            manholeGeometry.bottom,
            manholeGeometry.right,
            manholeGeometry.top,
            manholeGeometry.left,
            manholeGeometry.top
        ]
    }/>

    return (
        <Group x={manholeGeometry.tx} y={manholeGeometry.ty} rotation={manholeGeometry.rot}>
            {renderManholeOutline()}
            {renderVerticalClosureIntersections(manholeGeometry)}
            {renderHoldingBrackets()}
            {renderTypePlates(manholeGeometry, scale, manhole)}
        </Group>
    )
}
